const config = {
  bucketName: String(process.env.REACT_APP_AWS_BUCKET_URL),

  // Stripe Configuration
  stripePublishableKey: String(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY),
  stripeSecretKey: String(process.env.REACT_APP_STRIPE_SECRET_KEY),
  stripeApiUrl: String(process.env.REACT_APP_STRIPE_API_URL),
};

export default config;
